// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import FupUserModel from '../../model/fup-user-model';
import FupUserDTO from '../dto/fup-user-dto';
import dtoSchema from '../schemas/fup-user-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class FupUserModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<FupUserDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.organisationId = data.organisationId ?? undefined;
      this.organisationGenericName = data.organisationGenericName ?? undefined;
      this.email = data.email ?? undefined;
      this.lastName = data.lastName ?? undefined;
      this.firstName = data.firstName ?? undefined;
      this.userName = data.userName ?? undefined;
      this.lastLoginDate = data.lastLoginDate ?? undefined;
      this.lastActivityDate = data.lastActivityDate ?? undefined;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {uuid}
  */
  organisationId?: string;
  /**
  */
  organisationGenericName?: string;
  /**
  */
  email?: string;
  /**
  */
  lastName?: string;
  /**
  */
  firstName?: string;
  /**
  */
  userName?: string;
  /**
  * @type {date-time}
  */
  lastLoginDate?: string;
  /**
  * @type {date-time}
  */
  lastActivityDate?: string;

  static toModel(dto: DeepPartial<FupUserDTO>): FupUserModel;
  static toModel(dto: DeepPartial<FupUserDTO> | undefined | null): FupUserModel | undefined;
  static toModel(dto: DeepPartial<FupUserDTO> | undefined | null): FupUserModel | undefined {
    return dto ? new FupUserModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<FupUserModel> | FupUserModel): FupUserDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      organisationId: unwrapped.organisationId,
      organisationGenericName: unwrapped.organisationGenericName,
      email: unwrapped.email,
      lastName: unwrapped.lastName,
      firstName: unwrapped.firstName,
      userName: unwrapped.userName,
      lastLoginDate: unwrapped.lastLoginDate,
      lastActivityDate: unwrapped.lastActivityDate,
    } as FupUserDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for FupUserModel, can not map to FupUserDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
